import(/* webpackMode: "eager" */ "/tmp/8de4eff1d363bb9/app/[locale]/error.tsx");
